export default "__VITE_ASSET__b2CLj5kc__"